// La tabla mcp_usuarios_autorizados es global y vive solo en CEDESCA: el
// backend exige headquarter === 'CEDESCA' (z.literal), no hay selector de sede.
export const MCP_HEADQUARTER = 'CEDESCA';

export const PAGE_SIZE = 10;

export const ESTADO_TODOS = 'todos';

export const ESTADOS_FILTRO = [
  { value: ESTADO_TODOS, label: 'Todos' },
  { value: 'activo', label: 'Activos' },
  { value: 'inactivo', label: 'Inactivos' },
];

export const DEBOUNCE_MS = 300;

export const AVISO_MCP =
  'Los cambios tardan hasta 15 minutos en aplicarse en el MCP. Además de estar en esta lista, el acceso real depende de los permisos de la unidad organizativa (OU) de la persona.';

export const AVISO_PROPAGACION = 'Puede tardar hasta 15 min en aplicarse en el MCP.';

// Guia del boton Vincular (solo se pinta si hay filas "Sin vincular"). Vincular
// vuelve a guardar el email: el backend comprueba la cuenta en Google Workspace y
// guarda su google_sub, con el que el MCP exige que sea esa persona y no solo ese
// email. Sin google_sub la fila NO da acceso al MCP (apis-node lo exige desde el
// MCP integrado) y, si esta inactiva, no se puede reactivar (422 sin_google_sub).
export const AYUDA_VINCULAR =
  'Comprueba la cuenta en Google Workspace y asocia el acceso a esa persona, no solo a su email: si en el futuro ese email pasa a otra persona, no heredará el acceso. No cambia sus permisos ni le quita el acceso. Las filas «Sin vincular» no dan acceso al MCP y no se pueden reactivar hasta vincularlas: pulsa Vincular para que esa persona pueda conectarlo.';

export const MSG_SIN_PERMISO = 'No tienes permiso para gestionar el MCP';

export const NOTAS_MAX = 255;

// Tope defensivo del GET en el backend (LIMIT 1000).
export const LIMITE_LISTADO = 1000;
